export default "__VITE_ASSET__C9u2_erk__"